var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardSwitcher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2087 0.671875H4.45866C3.83678 0.671875 3.33366 1.175 3.33366 1.79688V11.5469C3.33366 12.1688 3.83678 12.6719 4.45866 12.6719H14.2087C14.8305 12.6719 15.3337 12.1688 15.3337 11.5469V1.79688C15.3337 1.175 14.8305 0.671875 14.2087 0.671875ZM14.2087 11.5469V1.79688H4.45866V11.5469H14.2087ZM6.396 8.77344H12.271C12.5819 8.77344 12.8335 9.025 12.8335 9.33594C12.8335 9.64688 12.5819 9.89844 12.271 9.89844H6.396C6.08506 9.89844 5.8335 9.64688 5.8335 9.33594C5.8335 9.025 6.08506 8.77344 6.396 8.77344ZM12.1045 15.3359H1.79199C1.17012 15.3359 0.666992 14.8328 0.666992 14.2109V3.89844C0.666992 3.5875 0.918554 3.33594 1.22949 3.33594C1.54043 3.33594 1.79199 3.5875 1.79199 3.89844V14.2109H12.1045C12.4154 14.2109 12.667 14.4625 12.667 14.7734C12.667 15.0844 12.4154 15.3359 12.1045 15.3359Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSwitcher);
export default __webpack_public_path__ + "static/media/DashboardSwitcher.3a0440468cdd69a17df6ef81f83403e2.svg";
export { ForwardRef as ReactComponent };